export default import.meta.ROLLDOWN_FILE_URL_y3WuTrdTs_Si7uYpRddj9w